import React from 'react';
import { FaTrophy } from 'react-icons/fa';
import './Leaderboard.css';

/**
 * Унифицированный компонент рейтинга для всех мини-игр
 * @param {Array} results - Список игроков из сокета (leaderboard)
 * @param {String} myName - Имя текущего пользователя для подсвечивания
 * @param {Function} t - Функция перевода
 */
const UnifiedLeaderboard = ({ results, myId, t }) => {
  if (!results || results.length <= 0) return null;

  return (
    <div className="unified-leaderboard">
      <div className="ul-title">
        <FaTrophy /> {t('arcade.leaderboard_top', 'РЕЙТИНГ')}
      </div>
      <div className="ul-list">
        {results.slice(0, 5).map((player, idx) => (
          <div
            key={idx}
            className={`ul-item ${player.userId === myId ? 'is-me' : ''}`}
          >
            <span className="ul-rank">{idx + 1}.</span>
            <span className="ul-name">{player.name}</span>
            <span className="ul-score">{player.score} 🌟</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnifiedLeaderboard;